import GlobalStyles from '@mui/material/GlobalStyles';
import { cssVar } from '@mfw/common';
import React from 'react';
import { onSurfaceMark } from '../../theme/onSurface';

// ----------------------------------------------------------------------

// Rebrandable primary via CSS var — the MUI JS theme is frozen at startup,
// so reading theme.palette here would keep the default brand color forever.
const inputGlobalStyles = (
  <GlobalStyles
    styles={{
      '#nprogress': {
        '.bar': {
          // The bar is a thin indicator along the top edge of the page, so it
          // takes the mark step; the glow around it is decorative and stays.
          backgroundColor: onSurfaceMark.primary,
          boxShadow: `0 0 2px ${cssVar.primary.main}`,
          height: 2.5,
          left: 0,
          position: 'fixed',
          top: 0,
          width: '100%',
          zIndex: 9999,
        },
        '.peg': {
          boxShadow: `0 0 10px ${cssVar.primary.main}, 0 0 5px ${cssVar.primary.main}`,
          display: 'block',
          height: '100%',
          opacity: 1,
          position: 'absolute',
          right: 0,
          transform: 'rotate(3deg) translate(0px, -4px)',
          width: 100,
        },
        pointerEvents: 'none',
      },
    }}
  />
);

function StyledProgressBar() {
  return inputGlobalStyles;
}

export default React.memo(StyledProgressBar);
